import { render, staticRenderFns } from "./MessageView.vue?vue&type=template&id=1bf9dd57&scoped=true&"
import script from "./MessageView.vue?vue&type=script&lang=js&"
export * from "./MessageView.vue?vue&type=script&lang=js&"
import style0 from "./MessageView.vue?vue&type=style&index=0&id=1bf9dd57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9dd57",
  null
  
)

export default component.exports